export const QR_REGISTRATION_SOURCE = 'qr_registration';

export function isQrRegistrationSource(source: string | null | undefined): boolean {
  return source === QR_REGISTRATION_SOURCE;
}
